// Destino del correo de verificación de Medplum (2026-09-13): el servidor arma
// el enlace como `${appBaseUrl}verifyemail/<id>/<secret>` (verificado en su
// código). Antes la servía el legado packages/hce. Sin sesión de Medplum (ver
// PREFIJOS_SIN_MEDPLUM en main.tsx).
import { normalizeErrorString } from '@medplum/core';
import { useMedplum } from '@medplum/react-hooks';
import type { JSX } from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useParams } from 'react-router';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';

export function VerificarCorreoPage(): JSX.Element {
  const { t } = useTranslation();
  const medplum = useMedplum();
  const { id = '', secret = '' } = useParams();
  const [enviando, setEnviando] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [exito, setExito] = useState(false);

  async function verificar(): Promise<void> {
    setError(null);
    setEnviando(true);
    try {
      await medplum.post('auth/verifyemail', { id, secret });
      setExito(true);
    } catch (err) {
      setError(`${t('auth.verificarCorreo.error')} (${normalizeErrorString(err)})`);
    } finally {
      setEnviando(false);
    }
  }

  return (
    <div className="min-h-screen bg-hce-paper flex items-center justify-center px-4 py-10">
      <div className="w-full max-w-sm bg-hce-surface border border-border rounded-lg shadow-sm p-6 space-y-4">
        <h1 className="text-base font-medium text-hce-ink">{t('auth.verificarCorreo.titulo')}</h1>
        {exito ? (
          <>
            <Alert>
              <AlertDescription>{t('auth.verificarCorreo.exito')}</AlertDescription>
            </Alert>
            <Button asChild className="w-full">
              <Link to="/login">{t('auth.nuevaContrasena.irALogin')}</Link>
            </Button>
          </>
        ) : (
          <>
            <p className="text-sm text-hce-muted">{t('auth.verificarCorreo.instruccion')}</p>
            {error && (
              <Alert variant="red">
                <AlertDescription>{error}</AlertDescription>
              </Alert>
            )}
            <Button disabled={enviando} className="w-full" onClick={() => void verificar()}>
              {enviando ? t('auth.verificarCorreo.verificando') : t('auth.verificarCorreo.verificar')}
            </Button>
          </>
        )}
      </div>
    </div>
  );
}
